import React from 'react';


export default function googlejobSchema({
    job,
    job_type,
    job_currency,
    job_payment_type,
    site_name,
    site_domain_link,
    site_google_logo_link
}) {
    const schemaData = {
        "@context": "https://schema.org/",
        "@type": "JobPosting",
        "title": `${job.title}`,
        "description": `${job.description}`,

        "identifier": {
            "@type": "PropertyValue",
            "name": `${site_name}`,
            "value": `${job.external_reference}`
        },
        "datePosted": `${job.created_at}`,
        "validThrough": `${job.expires_at}`,
        "hiringOrganization": {
            "@type": "Organization",
            "name": `${site_name}`,
            "sameAs": `${site_domain_link}`,
            "logo": `${site_google_logo_link}`
        },
        "employmentType": `${job_type}`,
        "jobLocation": {
            "@type": "Place",
            "address": {
                "@type": "PostalAddress",
                "streetAddress": `${job.location}`,
                "addressLocality": `${job.location}`,
                "addressRegion": `${job.location}`,
                "addressCountry": `${job.location}`,
                "postalCode": "-",
            }
        },
        "baseSalary": {
            "@type": "MonetaryAmount",
            "currency": `${job_currency}`,
            value: {
                '@type': 'QuantitativeValue',
                "value": `${job.salary_package}`,
                "unitText": `${job_payment_type}`
            }
        }

    }
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}


        />
    )
}